export enum LanguageCode {
  En = 'en',
  No = 'no',
  Sv = 'sv',
  Sw = 'sw',
  Es = 'es',
  Fr = 'fr',
  Cs = 'cs',
  Da = 'da',
  De = 'de',
  It = 'it',
}
export interface MembershipTypeMap {
  membership :string,
  license :string
  memberships:string,
  licenses:string
}

export const MembershipLabelByLang: Record<LanguageCode, MembershipTypeMap> = {
    [LanguageCode.En]: {
        membership: 'membership',
        memberships: 'memberships',
        license:'license',
        licenses:'licenses'
      },
      [LanguageCode.No]: {
        membership: 'medlemskap',
        memberships: 'medlemskap',
        license:'lisens',
        licenses:'lisenser'
      },
      [LanguageCode.Sv]: {
        membership: 'medlemskap',
        memberships: 'medlemskap',
        license:'licens',
        licenses:'licenser'
      },
      [LanguageCode.Sw]: {
        membership: 'medlemskap',
        memberships: 'medlemskap',
        license:'licens',
        licenses:'licenser'
      },
      [LanguageCode.Es]: {
        membership: 'membresía',
        memberships: 'membresías',
        license:'licencia',
        licenses:'licencias'
      },
      [LanguageCode.Fr]: {
        membership: 'adhésion',
        memberships: 'adhésions',
        license:'licence',
        licenses:'licences'
      },
      [LanguageCode.Cs]: {
        membership: 'členství',
        memberships: 'členství',
        license:'licence',
        licenses:'licence'
      },
      [LanguageCode.Da]: {
        membership: 'medlemskab',
        memberships: 'medlemskaber',
        license:'licens',
        licenses:'licenser'
      },
      [LanguageCode.De]: {
        membership: 'Mitgliedschaft',
        memberships: 'Mitgliedschaften',
        license:'Lizenz',
        licenses:'Lizenzen'
      },
      [LanguageCode.It]: {
        membership: 'abbonamento',
        memberships: 'abbonamenti',
        license:'licenza',
        licenses:'licenze'
      },
};
